import { lazy } from 'react';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "googlePayStubsModal" */ './GooglePayStubsModal')),
);

const LazyComponentWithSuspense = withSuspense<{}>(LazyComponent, 'GooglePayStubsModal');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as GooglePayStubsModal };
